import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../baseQuery";
import { shiftApi } from "../shift/shiftApi";

type CreateOvertime = Pick<Overtime, "employee_id" | "when" | "reason"> & {
  status?: Overtime["status"];
};

type UpdateOvertime = Partial<Overtime> & { id: number };

export type GetOvertimes = {
  start_date: string;
  status?: OvertimeStatus[];
};

export type GetOvertimesResponse = {
  overtimes: Overtime[];
  employees: Employee[];
};

export const overtimeApi = createApi({
  reducerPath: "overtimeApi",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getOvertimes: builder.query<GetOvertimesResponse, GetOvertimes>({
      query: ({ start_date, status }) => {
        return {
          url: `/api/overtime`,
          method: "GET",
          params: {
            start_date,
            status,
          },
        };
      },
    }),

    createOvertime: builder.mutation<Overtime, CreateOvertime>({
      query: (body) => ({
        url: "/api/overtime",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body,
      }),
      onQueryStarted: async (_arg, { dispatch, queryFulfilled }) => {
        await queryFulfilled;
        dispatch(shiftApi.util.invalidateTags(["WorkedShift"]));
      },
    }),

    updateOvertime: builder.mutation<Overtime, UpdateOvertime>({
      query: ({ id, ...rest }) => ({
        url: `/api/overtime/${id}`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: rest,
      }),
    }),
  }),
});

export const { useGetOvertimesQuery, useCreateOvertimeMutation, useUpdateOvertimeMutation } = overtimeApi;
